import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";

export default function AspenFaqAccordion() {
  const [expanded, setExpanded] = useState(null);

  const faqData = [
    {
      question: "Hvor stor er LYKKE ASPEN?",
      answer: "LYKKE ASPEN er 500 × 350 × 280 cm (ytre mål) med en grunnflate på cirka 17,5 m². Den passer perfekt for større hager og har plass til 6 personer."
    },
    {
      question: "Hva er inkludert i standardprisen?",
      answer: "Standardprisen inkluderer komplett badstue med ovn (elektrisk eller vedovn), benker, dør, innvendig panel, all isolasjon, dampsperre, LYKKE löyly PAKKE (bøtte, øse, termometer, timeglass), og installasjonstilbehør."
    },
    {
      question: "Hvor lang er leveringstiden?",
      answer: "Standard leveringstid for LYKKE ASPEN er 6–8 uker fra signert kontrakt til levering på stedet."
    },
    {
      question: "Kan jeg oppgradere materialene?",
      answer: "Ja, absolutt! Du kan velge mellom ulike innvendige paneler (f.eks. varmebehandlet tre), ulike gulvmaterialer (stein eller keramikk), LED-lysystemer, lydanlegg, og mer. Alle oppgraderinger kan konfigureres i konfiguratoren."
    },
    {
      question: "Er vedovn eller elektrisk ovn bedre?",
      answer: "Begge har fordeler. Vedovn gir en autentisk og tradisjonell badstuopplevelse med levende flamme, men krever skorstein. Elektrisk ovn er mer praktisk og krever kun elektrisitet. Velg etter dine preferanser og bygningstilstand."
    },
    {
      question: "Hvordan vedlikeholdes LYKKE ASPEN?",
      answer: "Regularvedlikehold inkluderer årlig inspeksjon av tak, drenering, og trebeskyttelse. Kebony-tre er behandlet og motstår fukt bedre, men bør behandles etter behov. Vi anbefaler årlig vedlikehold av eksponerte deler."
    }
  ];

  return (
    <div className="space-y-2">
      {faqData.map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
          className="border border-foreground/10 rounded-sm overflow-hidden"
        >
          <button
            onClick={() => setExpanded(expanded === index ? null : index)}
            className="w-full px-6 py-4 flex items-center justify-between hover:bg-foreground/3 transition-colors"
          >
            <span className="text-2xl font-body text-foreground text-left">{item.question}</span>
            <motion.div
              animate={{ rotate: expanded === index ? 180 : 0 }}
              transition={{ duration: 0.2 }}
              className="flex-shrink-0 ml-4"
            >
              <ChevronDown size={20} className="text-foreground/40" />
            </motion.div>
          </button>
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: expanded === index ? "auto" : 0, opacity: expanded === index ? 1 : 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-4 text-2xl text-foreground/60 leading-relaxed border-t border-foreground/5">
              {item.answer}
            </div>
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}